import { Panel } from '@/ui/atoms/panel/Panel'
import { ConnectCTAButtonGroup } from '@/ui/molecules/connect-cta-button-group/ConnectCTAButtonGroup'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'

interface ConnectCTAPanelProps {
  iconPaths?: string[]
  header: string
  buttonText: string
  action: () => Promise<void> | void
  source?: string
}

export function ConnectCTAPanel({ iconPaths, header, buttonText, action, source }: ConnectCTAPanelProps) {
  return (
    <Panel.Wrapper className="w-full max-w-md">
      <Panel.Content className="flex flex-col gap-6 p-6 text-center md:px-8">
        <div className="flex flex-col items-center gap-6">
          {iconPaths && <IconStack paths={iconPaths} size="lg" stackingOrder="first-on-top" />}
          <ConnectCTAButtonGroup header={header} action={action} buttonText={buttonText} source={source} />
        </div>
      </Panel.Content>
    </Panel.Wrapper>
  )
}
